import { formatMoney, formatDelta } from '../lib/format.js'

// Top-of-screen running total. Green if we're under the daily target, red if over.
// Shows the delta vs yesterday so the manager can see today's pace at a glance.
export default function RunningTotal({ todayTotal, yesterdayTotal, dailyTarget }) {
  const overTarget = Number(todayTotal) > Number(dailyTarget)
  const tone = overTarget
    ? { bg: 'bg-red-600',  ring: 'ring-red-600' }
    : { bg: 'bg-green-600', ring: 'ring-green-600' }

  const delta = Number(todayTotal) - Number(yesterdayTotal)
  const deltaWord =
    delta === 0 ? 'same as' : delta > 0 ? 'more than' : 'less than'

  return (
    <section
      className={`mx-4 mt-4 rounded-2xl text-white ${tone.bg} p-5 shadow-sm`}
      aria-label="Today's running waste total"
    >
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium font-medium opacity-90">
          Today's Waste
        </span>
        <span className="text-xs opacity-90">
          Target {formatMoney(dailyTarget)}
        </span>
      </div>

      <div className="mt-2 text-5xl font-medium leading-tight tabular-nums">
        {formatMoney(todayTotal)}
      </div>

      <div className="mt-2 text-sm opacity-95">
        {formatDelta(delta)} {deltaWord} yesterday ({formatMoney(yesterdayTotal)})
      </div>

      {overTarget && (
        <div className="mt-3 inline-flex rounded-md bg-white/15 px-2 py-1 text-xs font-medium">
          Over daily target
        </div>
      )}
    </section>
  )
}
